var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckBoxGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98411 0.811369L4.11124 4.68424L2.00412 2.57711C1.54503 2.11802 0.803414 2.11802 0.34432 2.57711C-0.114773 3.03621 -0.114773 3.77782 0.34432 4.23691L3.28723 7.17982C3.52266 7.40348 3.81695 7.5212 4.12301 7.5212C4.42908 7.5212 4.72337 7.40348 4.9588 7.17982L9.65568 2.48294C10.1148 2.02385 10.1148 1.28223 9.65568 0.823141C9.19659 0.364047 8.45497 0.364047 7.99588 0.823141L7.98411 0.811369Z",
    fill: "#E4E4ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxGrey);
export default __webpack_public_path__ + "static/media/check-box_grey.b04604f5576093789d8ed65c5a521de5.svg";
export { ForwardRef as ReactComponent };